import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { TokenizationFlowStep } from '../enums/enums.enum';

@Injectable({
  providedIn: 'root'
})
export class TokenizationFlowService {
  private readonly _flowStep = new BehaviorSubject<TokenizationFlowStep>(TokenizationFlowStep.IDLE);
  readonly flowStep$: Observable<TokenizationFlowStep> = this._flowStep.asObservable();

  setFlowStep(step: TokenizationFlowStep): void {
    this._flowStep.next(step);
  }

  getFlowStep(): TokenizationFlowStep {
    return this._flowStep.value;
  }
}
